import { END_POINTS } from '../helpers';
import { CommonBody, LoanAndYearData, LoanRequest } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetEquipmentResponse = {
  list: LoanAndYearData[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
};

type LoanRequestResponse = {
  data: LoanRequest[];
  count: number;
  currentPage: number;
  pendingCount: number;
  approvedCount: number;
  rejectedCount: number;
  totalPages: number;
};

export const loanInterestAndIntrestRateApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoanYearAndIntrestRates: builder.query<
      CommonResponse & { data: GetEquipmentResponse },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.getLoanYearAndIntrestRate}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }`,
        method: 'GET',
      }),
    }),

    deleteLoanYearAndIntrestRate: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteLoanYearAndIntrestRate}/${id}`,
        method: 'DELETE',
      }),
    }),
    getLoanYearAndIntrestRateById: builder.query<
      CommonResponse & { data: LoanAndYearData },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getLoanYearAndIntrestRateById}/${id}`,
        method: 'GET',
      }),
    }),

    addLoanYearAndIntrestRate: builder.mutation<
      CommonResponse & { data: LoanAndYearData },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addLoanYearAndIntrestRate}`,
        method: 'POST',
        body,
      }),
    }),
    updateLoanYearAndIntrestRate: builder.mutation<
      CommonResponse & { data: LoanAndYearData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateLoanYearAndIntrestRate}/${id}`,
        method: 'PUT',
        body,
      }),
    }),

    getLoanRequests: builder.query<
      CommonResponse & { data: LoanRequestResponse },
      { page: number; search: string; limit: number; statusType: number }
    >({
      query: ({ page, limit, search, statusType }) => ({
        url: `${END_POINTS.loanRequests}?status=${statusType}&page=${page}&limit=${limit}&search=${search}`,
        method: 'GET',
      }),
    }),

    updateLoanRequest: builder.mutation<
      CommonResponse & { data: LoanAndYearData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateLoanRequest}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetLoanRequestsQuery,
  useLazyGetLoanYearAndIntrestRatesQuery,
  useAddLoanYearAndIntrestRateMutation,
  useDeleteLoanYearAndIntrestRateMutation,
  useUpdateLoanYearAndIntrestRateMutation,
  useLazyGetLoanYearAndIntrestRateByIdQuery,
  useUpdateLoanRequestMutation,
} = loanInterestAndIntrestRateApi;
